import {
  FormDropdown,
  FormInput,
  validateRequired,
  validateRequiredDropdown,
} from 'components/shared/Forms/ReduxForm'
import { I18n } from 'lib/i18n'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Field, reduxForm } from 'redux-form'
import { createFamily } from 'redux/product'
import { Button, Divider, Form, Modal } from 'semantic-ui-react'

const i18nkey = 'admin.product.newProductFamilyModal.'

const mapStateToProps = (state, ownProps) => {
  const form = state.form[ownProps.form]
  const formValues = state.form && form && form.values
  const pathLeaves = [{ value: -1, text: I18n.t('global.no_category') }].concat(
    state.categories.pathLeaves
  )

  return { form, formValues, pathLeaves }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      createFamily,
    },
    dispatch
  )
}

class ProductFamilyModal extends React.Component {
  render() {
    const {
      formValues,
      createFamily,
      initialized,
      destroy,
      pathLeaves,
      form,
    } = this.props
    const hasErrors = !!(form && form.syncErrors)

    return (
      <Modal open={initialized} className="inverted">
        <Modal.Header>{I18n.t(i18nkey + 'title')}</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <Form>
              <Field
                component={FormInput}
                name="article_number"
                placeholder={I18n.t(i18nkey + 'article_number')}
                validate={validateRequired}
              />

              <Divider hidden className="compact" />

              <Form.Group widths="equal">
                <Field
                  component={FormInput}
                  name="title_de"
                  icon="flag"
                  placeholder={I18n.t('global.title_de')}
                  validate={validateRequired}
                />
                <Field
                  component={FormInput}
                  name="title_fr"
                  icon="flag outline"
                  placeholder={I18n.t('global.title_fr')}
                  validate={validateRequired}
                />
              </Form.Group>

              <Divider hidden className="ultra compact" />

              <Field
                label={I18n.t(i18nkey + 'create_in')}
                component={FormDropdown}
                fluid
                search
                selection
                placeholder={I18n.t('admin.productCategorySelector.select')}
                options={pathLeaves}
                onChange={(event, newValue, previousValue) => {
                  console.log(newValue)
                }}
                name="product_category_ids"
                validate={validateRequiredDropdown}
              />
            </Form>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            onClick={(event) => {
              event.preventDefault()
              destroy()
            }}
            color="black">
            {I18n.t('admin.user.button.cancel')}
          </Button>
          <Button
            onClick={(event) => {
              event.preventDefault()
              const family = {
                ...formValues,
                product_category_ids: [formValues.product_category_ids],
              }
              createFamily(family)
              destroy()
            }}
            positive
            icon="checkmark"
            labelPosition="right"
            content={I18n.t('admin.user.button.save')}
            disabled={hasErrors}
          />
        </Modal.Actions>
      </Modal>
    )
  }
}

ProductFamilyModal = connect(mapStateToProps, mapDispatchToProps)(
  ProductFamilyModal
)
ProductFamilyModal = reduxForm({ form: 'new_product_family_modal' })(
  ProductFamilyModal
)
export default ProductFamilyModal



// WEBPACK FOOTER //
// ./src/components/admin/Products/Segments/ProductFamilyModal.jsx